import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { apiName } from "./data.service";
import { Endereco } from "./endereco.model";

@Injectable()
export class EnderecoApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Endereco, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Endereco, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"logradouro"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGetPostId(apiName, objectId, {}, done);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/enderecos/shared/endereco-api.service.ts
 **/